import {requestGet, requestPost} from '@/utils/request';

const api = {
    LIST: '/content/page_list',
    ADD: '/content/page_add',
    UPDATE: '/content/page_update',
}

export async function pageList(queryParams) {
    return requestGet(api.LIST, queryParams);
}

export async function pageAdd(form) {
    return requestPost(api.ADD, form);
}

export async function pageUpdate(form) {
    return requestPost(api.UPDATE, form);
}

